import React from "react";
import _ from 'lodash'
import { BootstrapGridStyles } from 'styles/components/atoms/BootstrapGrid'
import { createStyles, ThemedValues } from 'styles/themed'
import { View } from 'react-native'
import VStack from 'components/atoms/stack/VStack'
import { deviceSize, useViewportLayout } from 'utils/helper-device'

export const Grid = ( props ) => {
	let propStyle = _.get( props, 'style', {} );
	if( !_.isArray( propStyle ) ) {
		propStyle = [ propStyle ]
	}
	
	const space = _.get( props, 'space', false )
	if( space !== false ) {
		propStyle.push({
			gap: space
		})
	}
	
	const style = [
		BootstrapGridStyles.grid,
		...propStyle
	];
	
	return (
		<View
			{...props }
			style={ style }>
			
			{ props.children }
		</View>
	)
}

export const Container = ( props ) => {
	let propStyle = _.get( props, 'style', {} );
	if( !_.isArray( propStyle ) ) {
		propStyle = [ propStyle ]
	}
	
	const style = [
		BootstrapGridStyles.container,
		...propStyle
	]
	
	return (
		<View
			{...props}
			style={ style }>
			
			{ props.children }
		</View>
	)
}

export const Row = ( props ) => {
	const { size } = useViewportLayout();
	let propStyle = _.get( props, 'style', {} );
	if( !_.isArray( propStyle ) ) {
		propStyle = [ propStyle ]
	}
	
	const style = [
		BootstrapGridStyles.row,
		...propStyle
	]
	
	const align = _.get( props, 'align', false )
	if( align !== false ) {
		style.push({
			alignItems: align
		})
	}
	
	const justify = _.get( props, 'justify', false )
	if( justify !== false ) {
		style.push({
			justifyContent: justify
		})
	}
	
	const space = _.get( props, 'space', false )
	if( space !== false ) {
		style.push({
			gap: space
		})
	}
	
	const viewStyle = style
	
	if( props.chunk ) {
		
		const chunkSize = deviceSize.parse( props.chunk, size )
		
		let children = props.children
		
		if( !Array.isArray( props.children ) ) {
			children = [ props.children ]
		}
		
		// Chunk the children
		children = _.chunk( children, chunkSize )
		
		return (
			<VStack
				flex={ null }
				space={ ThemedValues.stackSpace }>
				
				{ _.map( children, ( items, index ) => {
					return (
						<View
							key={ `row-chunk-${ index }` }
							{ ...props }
							style={[ viewStyle ]}>

							{ items }
						</View>
					);
				})}
			</VStack>
		)
	}
	
	return (
		<View
			{ ...props }
			style={ viewStyle }>
			
			{ props.children }
		</View>
	)
}

export const Column = ( props ) => {
	const { size } = useViewportLayout();
	const style = createStyles( [ BootstrapGridStyles.column ], props )
	
	if( props.span ) {
		if( _.isNumber( props.span ) || props.span === undefined ) {
			style.push({
				flex: props.span
			});
		} else if( _.isObject( props.span ) ) {
			style.push({
				flex: deviceSize.parse( props.span, size )
			});
		}
	}
	
	const viewStyle = style
	
	return (
		<View
			{...props}
			style={ viewStyle }>
		
			{ props.children }
		</View>
	)
}

